<template>


  <t-report-generate
      v-model="form"
      sub-validation-tag="sub-checklist-report-photos-estate-inspection"
      modal
      default-pdf
      enable-generate-pdf
      enable-generate-word
      enable-setting
      enable-report-by-part
      help="Somente serão consideradas inspeções e ambientes finalizados. Para configurar as informações do cabeçalho utilize o cadastro de empresas."
      origin="Teste de Origem"
      button-title="Relatório"
      :relation-key="form.checklistId"
      java-report
      title="Laudo de Inspeção Imobiliário">

    <template #default="{status}">

      <t-input-code-label :command="'insert'" :status="status" required enterprise
                          v-model="form.enterpriseId" @change="getChecklistByEnterprise"/>


      <t-input-search v-if="form.enterpriseId > 0" v-model="form.checklistId"
                      required
                      :options="checklistOptions"
                      @change="getResumeTypeChecklistModel"
                      placeholder="Todas"
                      label="Inspeção" select/>

      <t-input label="Inspeção" v-else placeholder="Selecione um imóvel" disabled/>

      <t-input v-model="form.titleReport" required label="Título do Relatório" small="Título padrão de acordo com o modelo de inspeção"/>

      <b-row>

        <b-col cols="6">

          <b-form-checkbox class="mt-2 mb-2" v-model="form.enableEstateStatusColor" switch>
            Exibir critério de cores
          </b-form-checkbox>

        </b-col>

        <b-col cols="6">

          <b-form-checkbox class="mt-2 mb-2" v-model="form.enablePhotos" switch>
            Exibir imagens <t-help title="Caso queira somente o descritivo dos itens, desmarque esta opção" />
          </b-form-checkbox>

        </b-col>

      </b-row>

    </template>

    <template #setting>

      <t-msg info>Acesse o
        <b-link :to="{path:'/admin/company/'}" target="_blank">cadastro de empresas</b-link>
        para realizar a configuração do cabeçalho do relatorio
      </t-msg>

<!--      <t-input-search required select v-model="form.reportLayout"
                      :options="ReportEvidenceLayoutType.list"
                      label="Layout padrão"/>-->

<!--      <b-form-checkbox class="mt-2 mb-2" v-model="form.subtitleSequenceEnable" switch>
        Inserir numeração na legenda?
      </b-form-checkbox>-->

<!--      <t-input label="Começar númeração das fotos por" :disabled="!form.subtitleSequenceEnable"
               v-model="form.subtitleSequenceStart"/>-->

<!--      <b-form-checkbox class="mt-2 mb-2" v-model="form.reportHideHeaderFooter" switch>
        Ocultar todas informações do cabeçalho e rodapé?
      </b-form-checkbox>

      <b-form-checkbox class="mt-2 mb-2" v-model="form.reportHideSpotFolderDivision" switch>
        Ocultar informações da Divisão e Pavimento?
      </b-form-checkbox>

      <b-form-checkbox class="mt-2 mb-2" v-show="!form.reportHideSpotFolderDivision" v-model="form.reportBreakPageBySpotFolder" switch>
        Habilitar quebra de página por pavimento?
      </b-form-checkbox>-->

      <t-input-search required radio v-show="!form.reportHideHeaderFooter" v-model="form.reportHeaderPositionLogo"
                      :options="ReportPositionLogoHeaderType.list" label="Cabeçalho logomarca"/>


<!--      <t-input v-model="form.environmentSort" required stacked
               :options="ReportEnvironmentSortType.list"
               radio
               label="Ordenação dos ambientes"/>-->
<!--
      <t-input radio required stacked v-model="form.subtitleFormat"
               :options="ReportSubtitleType.list" label="Formato das legendas"/>-->

      <b-form-checkbox class="mt-2 mb-2" v-model="form.reportShowCover" switch>
        Exibir a capa?
      </b-form-checkbox>

    </template>

  </t-report-generate>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageReportItemMixin from "@/mixins/page/pageReportItemMixin"
import checklistService from "@/services/modules/checklist/Checklist.service";
import StatusChecklistType from "@/model/types/modules/checklist/StatusChecklistType";
import ReportEvidenceLayoutType from "@/model/types/modules/checklist/ReportEvidenceLayoutType";
import ReportPositionLogoHeaderType from "@/model/types/modules/checklist/ReportPositionLogoHeaderType";
import TypeChecklistModelService from "@/services/modules/checklist/TypeChecklistModel.service";
import ChecklistService from "@/services/modules/checklist/Checklist.service";
import ReportEnvironmentSortType from "@/model/types/modules/checklist/ReportEnvironmentSortType";
import ReportSubtitleType from "@/model/types/modules/checklist/ReportSubtitleType";

export default {

  mixins: [pageDefaultMixin, pageReportItemMixin],
  name: 'ReportPhotoChecklistEvidence',
  data() {
    return {
      ReportEvidenceLayoutType,
      ReportPositionLogoHeaderType,
      ReportEnvironmentSortType,
      ReportSubtitleType,
      path: "checklist/report", //Path padrão para validação, porém página foi configurada para validação direta na mesma página (validationOtherPageId)
      form: {
        enterpriseId: this.enterpriseId,
        checklistId: this.checklistId,
        titleReport: "",
        subtitleReport: "",
        reportHideHeaderFooter: false,
        reportHideSpotFolderDivision: false,
        reportBreakPageBySpotFolder: false,
        enableEstateStatusColor: true,
        enablePhotos: true,
        reportLayout: ReportEvidenceLayoutType.type.BASIC_4_PHOTOS_PORTRAIT,
        reportHeaderPositionLogo: ReportPositionLogoHeaderType.type.LEFT,
        environmentSort: ReportEnvironmentSortType.type.DEFAULT,
        subtitleFormat: ReportSubtitleType.type.BASIC,
        subtitleSequenceEnable: true,
        subtitleSequenceStart: 1,
        reportShowCover: true,
      },
      checklistOptions: [],
    }
  },
  props: {
    enterpriseId: Number,
    checklistId: Number,
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      if (this.enterpriseId > 0) {
        await this.getChecklistByEnterprise()
      }

      if(this.checklistId > 0) {
        await this.getResumeTypeChecklistModel()
      }


    },

    async getChecklistByEnterprise() {

      //Limpa o checklist
      this.form.checklistId = this.checklistId

      let params = new URLSearchParams()
      params.append("enterpriseId", this.form.enterpriseId)
      params.append("status", 1)
      params.append("sorted", "issueDate desc,checklistNumber desc")
      params.append("statusChecklist", StatusChecklistType.type.FINISHED)
      await checklistService.selectList(params).then((list) => {
        this.checklistOptions = list
      }).catch(error => this.responseError(error))

    },

    async getResumeTypeChecklistModel() {

      setTimeout(async () => {

        if (this.form.checklistId > 0) {

          await ChecklistService.getResume("id", this.form.checklistId).then(async checklistResume => {

            await TypeChecklistModelService.getResume("id", checklistResume.typeChecklistId).then(resume => {

              this.form.titleReport = resume.reportEvidenceDefaultTitle
              this.form.subtitleReport = resume.reportEvidenceDefaultSubtitle

              /*IDEM EM WORK EVIDENCE E CHECKLIST EVIDENCE*/
              this.form.reportLayout = resume.reportEvidenceDefaultLayout
              this.form.reportHeaderPositionLogo = resume.reportEvidenceDefaultHeaderPositionLogo
              this.form.reportHideHeaderFooter = resume.reportEvidenceDefaultHideHeaderFooter
              this.form.reportHideSpotFolderDivision = resume.reportEvidenceDefaultHideSpotFolderDivision
              this.form.reportHideEnvironment = resume.reportEvidenceDefaultHideEnvironment
              this.form.reportBreakPageBySpotFolder = resume.reportEvidenceBreakPageBySpotFolder
              this.form.reportShowCover = resume.reportEvidenceShowCover
              this.form.environmentSort = resume.reportEvidenceDefaultEnvironmentSort
              this.form.subtitleFormat = resume.reportEvidenceDefaultSubtitleFormat
              /*---*/


            })

          })

        }

      }, 100)

    }


  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
